import classNames from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Box } from '~/components/elements/Box'
import { Typography } from '~/components/elements/Typography'
import { VStack } from '~/components/elements/VStack'
import { AmplitudeProvider } from '~/components/providers/AmplitudeEventProvider'
import {
  formatNineSegment,
  nineSegmentIntentionI18nKeyMap,
  nineSegments,
} from '~/utils'

import { eventNameSuffixMap, indicatorLabelI18nKeyMap } from '../../utils'

import { DistributionChart } from './DistributionChart'
import styles from './DistributionCharts.css'
import { HeadingContainer } from './HeadingContainer'

export const DistributionCharts = () => {
  const { t } = useTranslation()

  return (
    <AmplitudeProvider eventNameSuffix={eventNameSuffixMap.distribution}>
      <HeadingContainer
        indicator="distribution"
        label={t(indicatorLabelI18nKeyMap['distribution'])}
      >
        <Box className={styles.charts}>
          {nineSegments.map((nineSegment) => (
            <VStack
              key={nineSegment}
              className={classNames(
                styles.container,
                styles[`container-${nineSegment}`],
              )}
              reverse={
                t(nineSegmentIntentionI18nKeyMap[nineSegment]) === t('passive')
              }
              spacing={1}
            >
              <Typography variant="heading3">
                {formatNineSegment(nineSegment, '%n. %t1', t)}
              </Typography>

              <DistributionChart nineSegment={nineSegment} />
            </VStack>
          ))}
        </Box>
      </HeadingContainer>
    </AmplitudeProvider>
  )
}
